import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Card, Alert, Spinner } from 'react-bootstrap';
import api from '../services/api'; // Assuming you have a configured api service

const VerificationPage = () => {
  // Get the uid and token from the URL (e.g., /verify/:uid/:token)
  const { uid, token } = useParams();
  const navigate = useNavigate();

  // State to manage the verification process
  const [status, setStatus] = useState('verifying'); // 'verifying', 'success', 'error'
  const [message, setMessage] = useState('Verifying your email address...');

  useEffect(() => {
    // This function will run once when the component loads
    const verifyEmail = async () => {
      if (!uid || !token) {
        setStatus('error');
        setMessage('Verification link is incomplete.');
        return;
      }

      try {
        // Make the API call to the backend
        const response = await api.get(`/users/verify/${uid}/${token}/`);
        
        // Handle success from the backend
        setStatus('success');
        setMessage(response.data.message || 'Verification successful!');

      } catch (error) {
        // Handle error from the backend
        setStatus('error');
        const errorMessage = error.response?.data?.error || 'Verification failed. The link may be invalid or expired.';
        setMessage(errorMessage);
      }
    };

    verifyEmail();
  }, [uid, token]); // Effect depends on uid and token

  useEffect(() => {
    // This effect runs when the status changes to 'success' or 'error'
    if (status === 'success' || status === 'error') {
      // Wait for 4 seconds before redirecting to the login page
      const timer = setTimeout(() => {
        navigate('/login'); // Redirect to the login page
      }, 4000);

      // Cleanup the timer if the component is unmounted before the time is up
      return () => clearTimeout(timer);
    }
  }, [status, navigate]); // Effect depends on status and navigate

  return (
    <Container className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
      <Card style={{ width: '30rem', padding: '2rem' }}>
        <Card.Body className="text-center">
          <Card.Title>Email Verification</Card.Title>
          <hr />
          
          {/* While verifying, show a spinner */}
          {status === 'verifying' && (
            <div>
              <Spinner animation="border" role="status" className="mb-3">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
              <p>{message}</p>
            </div>
          )}

          {/* On success, show a success alert */}
          {status === 'success' && (
            <Alert variant="success">{message}</Alert>
          )}

          {/* On error, show a danger alert */}
          {status === 'error' && (
            <Alert variant="danger">{message}</Alert>
          )}

          <p className="mt-3 text-muted">You will be redirected shortly...</p>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default VerificationPage;